import { useEffect, useState } from 'react';

import { getReactPixel } from '../../common/external-library/getReactPixel';
import { usePathnameMethod } from '../usePathnameMethod';

const useReactPixel = () => {
  const { pathname } = usePathnameMethod();

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getReactPixel()
      .then(({ init }) => init('207815741497179'))
      .then(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (!loaded) return;

    getReactPixel().then(({ pageView }) => pageView());
  }, [pathname, loaded]);
};

export default useReactPixel;
